import React, { useState, useEffect } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Paper,
  InputBase,
} from "@mui/material";
import { availableAPIs } from "../../utils/api_list";
import { useDispatch } from "react-redux";
import { apiActions } from "/src/redux/slices/apiHelpSlice";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import InputOutlinedIcon from '@mui/icons-material/InputOutlined';
import OutputOutlinedIcon from '@mui/icons-material/OutputOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PermDataSettingOutlinedIcon from '@mui/icons-material/PermDataSettingOutlined';
import StorageIcon from '@mui/icons-material/Storage';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SettingsInputHdmiOutlinedIcon from '@mui/icons-material/SettingsInputHdmiOutlined';

const SideNavbar = () => {
  const [open, setOpen] = useState({});
  const [val, setVal] = useState("");
  const [activeItem, setActiveItem] = useState("get_workflow");
  const dispatch = useDispatch();
   const categoryIcon = {
    'Inbound Template':<InputOutlinedIcon/>,
    'Outbound Template':<OutputOutlinedIcon/>,
    'Workflow':<CategoryOutlinedIcon/>,
    'Trading Partner': <span class="PARTNER_EXCHANGE"></span>,
    'Data Depot': <StorageIcon />,
    'Tracking Reports': <span class="ANALYTICS"></span>,
    'Account Data': <ListAltIcon />,
    'Predefined Connection': <span class="MATTER"></span>,
    'Database': <span className="DATABASE"></span>,
    'Utilities':<MiscellaneousServicesOutlinedIcon/>,
    'Testing Templates': <ArticleOutlinedIcon/>,
    'Testing Workflows' : <PermDataSettingOutlinedIcon/>,
     'Plugin' : <SettingsInputHdmiOutlinedIcon />
   }
  useEffect(() => {
    if (availableAPIs.length > 0) {
      const firstCategory = availableAPIs[0].category;
      setOpen({ [firstCategory]: true });
    }
  }, []);

  const handleCollapse = (category) => {
    setOpen((prevState) => ({
      ...prevState,
      [category]: !prevState[category],
    }));
  };

  const handleSelectedApi = (val) => {
    setActiveItem(val);
    dispatch(apiActions.setActiveApi(val));
  };

  const handleSearchChange = (e) => {
    setVal(e.target.value);
  }
  
  const getApiList = () => {
    const categories = [];
    const element = [];

    availableAPIs.forEach((o, k) => {
      if (!categories.includes(o.category)) {
        categories.push(o.category);
        const categoryElements = availableAPIs
          .filter((e) => e.category === o.category)
          .map((api, key) => (
            <Collapse
              in={open[o.category]}
              timeout="auto"
              unmountOnExit
              key={`api-${key}`}>
              <List disablePadding style={{width:'auto'}}>
                <ListItem
                  className="nested"
                  style={{
                    margin: "0",
                    marginTop: "-10px",
                    marginLeft: "26px",
                  }}
                  onClick={() => {
                    handleSelectedApi(api.val);
                  }}>
                  <div>
                    <ListItemText
                      primary={api.val}
                      primaryTypographyProps={{
                        fontSize: "14px",
                        margin: 0,
                        color:
                          activeItem === api.val
                            ? "gray"
                            : "",
                      }}
                      className="req-name"
                    />
                  </div>
                </ListItem>
              </List>
            </Collapse>
          ));

        element.push(
          <React.Fragment key={k}>
            <ListItem onClick={() => handleCollapse(o.category)} id={k} divider>
              <ListItemIcon style={{minWidth:'20px'}}>
                {categoryIcon[o.category]}
              </ListItemIcon>
              <ListItemText
                primary={o.category}
                className="category"
                primaryTypographyProps={{ fontSize: "14px",margin:0 }}
              />
              <span>
                {open[o.category] ? (
                  <ExpandLess style={{fontSize:'1.2rem'}} />
                ) : (
                  <ExpandMore style={{fontSize:'1.2rem'}} />
                )}
              </span>
            </ListItem>
            {categoryElements}
          </React.Fragment>
        );
      }
    });

    return <List component='nav'>{element}</List>;
  };

  return (
    <div>
      <div className="left-sidebar-container">
        <div className="request-left-sidebar">
            <Paper
              component="form"
              className="search-bar">
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search..."
                inputProps={{ "aria-label": "search..." }}
                value={val}
                onChange={handleSearchChange}
              />
              <IconButton
                type="button"
                sx={{ p: "3px", m: 0 }}
                aria-label="search">
                <SearchIcon />
              </IconButton>
            </Paper>
          <div className="inner-sidebar scrollBar">
            <div>{getApiList()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNavbar;
